module.exports = __webpack_public_path__ + "img/horizontal_4_4_r_pp1_0.107cd6c4.png";